module.exports = __webpack_public_path__ + "static/media/pagstar.99aca990.png";